var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({staticClass:"q-search-field",attrs:{"disabled":_vm.isDemoMode,"append-icon":"fa fa-search"},model:{value:(_setup.search),callback:function ($$v) {_setup.search=$$v},expression:"search"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }